<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Bank/Cash Account 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-form-group label-cols=3 label="Bank/Cash Account">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.kode" placeholder="Code"></b-form-input></b-col>
                <b-col class="pl-1" cols="8"><b-form-input v-model="tblData.namabank" placeholder="Account Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label-cols=3 label="Active">
              <b-row>
                <b-col cols="3" class="pr-1">
                  <b-form-select v-model="tblData.aktif" :plain="true" :options="dataList.YesNoAll"></b-form-select>                          
                </b-col>
                <b-col cols="3" class="pl-1">
                      <b-form-select v-model="tblData.isbank" :plain="true" :options="dataList.BankOrCashAll"></b-form-select>                          
                </b-col>  
                <b-col cols="6" class="pr-0">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(kodeacc)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.kodeacc}}</span>
            <span v-else style="color:green;">{{data.item.kodeacc}}</span>
        </template>  
        <template v-slot:cell(namabank)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank}}</span>
            <span v-else style="color:green;">{{data.item.namabank}}</span>
        </template>  
        <template v-slot:cell(matauang)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.matauang}}</span>
            <span v-else style="color:green;">{{data.item.matauang}}</span>
        </template>  
        <template v-slot:cell(namabank2)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank2}}</span>
        </template>  
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-show="showForm">
      <div slot="header">Bank/Cash Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col class="pr-4" cols="6">
              <b-input-group >
                  <b-input-group-prepend><label>Account Type</label></b-input-group-prepend>
                  <b-form-select v-model="frmdata.isbank" :plain="true" :options="dataList.BankOrCash"></b-form-select>                          
                  <b-input-group-append><span class="p-2">Active</span> </b-input-group-append>
                  <b-form-select v-model="frmdata.aktif" :plain="true" :options="dataList.YesNo"></b-form-select>                          
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>GL Account</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.glAccount" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('debit')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Account Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namabank" :state="!$v.frmdata.namabank.$error"></b-form-input>
              </b-input-group>
              <b-row>
                  <b-col cols="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Original Currency</label></b-input-group-prepend>
                        <b-form-select class="input-group-text" v-model="frmdata.matauang" :state="!$v.frmdata.matauang.$error" :plain="true" :options="currency" ></b-form-select>
                    </b-input-group>
                  </b-col>
              </b-row>

          </b-col>
          <b-col cols="6">
              <b-input-group >
                  <b-input-group-prepend><label>Nama Bank</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namabank2" :state="!$v.frmdata.namabank2.$error"></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Kantor Cabang</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.cabang" ></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Nomor Rekening</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.nomorrek" :state="!$v.frmdata.nomorrek.$error"></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Pemilik Rekening</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.bankAccName" :state="!$v.frmdata.bankAccName.$error"></b-form-input>
              </b-input-group>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import bankcashacc from "../../apis/bankcashacc";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import dropdown from "../../data/dropdown";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        namabank: { required },
        kodeacc: { required },
        matauang: { required },
        namabank2: {required : (function() {
                if (!(this.frmdata.isbank!='1')) {
                    return true;
                } else if (!(this.frmdata.namabank2)) {
                    return false;
                } else return true;
            })},
        nomorrek: {required : (function() {
                if (!(this.frmdata.isbank!='1')) {
                    return true;
                } else if (!(this.frmdata.nomorrek)) {
                    return false;
                } else return true;
            })},
        bankAccName: {required : (function() {
                if (!(this.frmdata.isbank!='1')) {
                    return true;
                } else if (!(this.frmdata.bankAccName)) {
                    return false;
                } else return true;
            })},

    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      currency:[],
      uanguser:this.$store.state.user.matauang,
      frmdata:{frmmode:'add', namabank: '', kodeacc: '', glAccount:'', kode: '', matauang: '', aktif:'0', isbank:'1', namabank2:''},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: 'namabank',
        sortDesc: false,aktif:'1',isbank:''
      },
      tblFields:[
        {
          key: "kodeacc",
          label: "GL Account",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "namabank",
          thStyle: "width:250px",
          label: "Account Name",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "Rp,$,¥",
          sortable: true
        },
        {
          key: "namabank2",
          label: "Nama Bank",
          thStyle: "width:250px",
          sortable: true
        },
        {
          key: "nomorrek",
          label: "Nomor Rekening",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "bankAccName",
          label: "Pemilik Rekening",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "cabang",
          label: "Cabang",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "aktif",
          label: "Active",
          thStyle: "width:40px",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        }          
      ],
      dataList: {
        YesNo: dropdown.YesNo,
        YesNoAll: dropdown.YesNoAll,
        BankOrCash: [{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
        BankOrCashAll: [{value: '', text: '-ALL-'},{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
      }      

    };
  },
  components: {lkuCoa},
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function (){
     this.currency = await bankcashacc.currency(); 
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            const response = await bankcashacc.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await bankcashacc.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.namabank=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.frmdata.aktif='1';  
      this.frmdata.frmmode='add';
      this.showForm=true;
      this.showList=false;
    },
    edit: function(data) {
        this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.kodelama=this.model.kode;  
      this.frmdata.isbank = (this.frmdata.isbank || 1).toString();
      this.frmdata.aktif = (this.frmdata.aktif || 0).toString();
      // this.frmdata.glAccount = (data.kodeacc || '').trim() + ' | ' + (data.namabank || '').trim();
      this.frmdata.glAccount = data.kodeacc ;
      this.frmdata.frmmode='edit';
      this.showForm=true;
      this.showList=false;
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await bankcashacc.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await bankcashacc.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.kodeacc = _selected.kodeacc;
            this.frmdata.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
